<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='10'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">询价单</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <div class="cght_ddgltop">
              <ul class="cght_ddglnavula">
                <li><a class="cght_ddglnavulaxz">询价单</a></li>
              </ul>
              <!-- <div class="cght_ddglright">
                <div class="cght_ddglrightr"><div><em><input type="text" /></em><a href="#"></a></div></div>
              </div> -->
            </div>
            <div class="cght_spsctibt" v-if="list.length">
              <div class="cght_spsctibtl">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              </div>
              <div class="cght_spsctibtl cght_spsctibtla"><a href="javascript:;" @click="delCollect">删除</a></div>
            </div>
            <ul class="cght_spscpicul qlnomar5" v-loading="qyloading" v-if="list.length">
              <li class="cght_showhidety2 this_page_css" v-for="(item,index) in list" :key="index">
                <div class="cght_spscpicul2">
                  <em>
                    <el-checkbox v-model="item.checkType" @change="handleCheckedCitiesChange(item,index)"></el-checkbox>
                  </em>
                  <h3 style="width:10%;float:left;">姓名：{{item.name}}</h3>
                  <h3 style="width:20%;float:left;margin-left:30px">询价时间：{{item.create_time}}</h3>
                  <h3 style="width:18%;float:left;margin-left:30px">我的询价单：
                    <el-button type="primary" size="mini" @click="downloadht(item)">
                      下载<i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                  </h3>
                  <h3 style="width:10%;float:left;margin-left:30px">是否回复：<span :style="item.is_back?'color:#ff6000;':''">{{item.is_back==0?'否':'是'}}</span></h3>
                  <h3 style="float:left;margin-left:40px" v-if="item.is_back">回复单：
                    <el-button type="primary" size="mini" @click="downloadhf(item)">下载<i class="el-icon-upload el-icon--right"></i></el-button>
                  </h3>
                  <el-button slot="reference" type="danger" style="margin-right:15px;margin-top:7px;float:right;" size="mini" plain icon="el-icon-delete" @click="aloneDel(item)">删除</el-button>
                </div>
              </li>
            </ul>
            <div class="cght_meiyoudingdansc" v-if="emptyShow&&list.length==0">
              <div class="cght_meiyoudingdanscd">
                <em>您还没有过任何询价哦~</em>
                <!-- <router-link :to="{path:'/'}" class="cght_meiyoudingdanscda">去首页看看</router-link> -->
              </div>
            </div>
            <div class="cght_height16"></div>
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/inquiry'
export default {
  name: 'Inquiry',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      qyloading: false,
      checkedArr: [],
      checkAll: false,
      isIndeterminate: true,
      listQuery: {
        limit: 10
      },
      id_list: [],
      emptyShow: false
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    LoadData () {
      this.qyloading = true // 页面区域loading
      this.api.query(this.listQuery).then(response => {
        let forlist = response.data.items
        forlist.forEach(res => {
          res.cancel = false
          res.checkType = false
        })
        this.id_list = response.data.id_list
        this.list = forlist
        this.total = response.data.total
        this.emptyShow = true
        this.qyloading = false
      })
    },
    cancelCollect (index) {
      this.list[index].cancel = !this.list[index].cancel
    },
    aloneDel (item) {
      this.$confirm('是否删除当前询价单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delete({id: item.id}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {
      })
    },
    delCollect () {
      if (this.checkedArr.length < 1) {
        this.$message.error('请先选择要删除的询价单')
        return
      }
      this.$confirm('是否删除所选的询价单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delete({id: this.checkedArr}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {
      })
    },
    handleCheckAllChange () {
      this.isIndeterminate = false
      if (this.checkAll) {
        this.list.forEach(res => { res.checkType = true })
        this.checkedArr = this.id_list
      } else {
        this.list.forEach(res => { res.checkType = false })
        this.checkedArr = []
      }
    },
    handleCheckedCitiesChange (item, index) {
      if (item.checkType) {
        this.checkedArr.splice(index, 0, item.id)
      } else {
        this.checkedArr.splice(this.checkedArr.indexOf(item.id), 1)
      }
      if (this.list.length === this.checkedArr.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    downloadht (item) {
      window.open(item.filepath)
    },
    downloadhf (item) {
      if (item.backfile) {
        window.open(item.backfile)
      }
    }
  }
}
</script>
<style scoped>
  .this_page_css {
    border-radius:5px ;
    margin: 15px 3px 0 3px;
    padding: 10px 3px 10px 3px;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
    width: 98%;
  }
  .this_page_css:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .cght_spscpicul2{
    height: 45px;
    width: 100%;
  }
  .cght_spscpicul2 h3{
    height: 45px;
    line-height: 45px;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .cght_spscpicul li{
    height: 50px;
  }
  .cght_meiyoudingdansc{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/inquiry.vue